import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c993397a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c993397a&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=c993397a&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c993397a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c993397a')) {
      api.createRecord('c993397a', component.options)
    } else {
      api.reload('c993397a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c993397a&scoped=true", function () {
      api.rerender('c993397a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/BookLogistic/index.vue"
export default component.exports